module.exports = __webpack_public_path__ + "img/36_22.dd65eeff.png";